import Vue from "vue";
import configs from "../configs";
import queryString from "query-string";

const ip = configs.apiBase;

const referenciarCadastradosEmpresa = (params) => {
  return Vue.prototype.$http.post(`${ip}/icms/produto/isento/empresa`, params);
};

const referenciarCadastradosFornecedor = (params) => {
  return Vue.prototype.$http.post(
    `${ip}/icms/produto/isento/fornecedor`,
    params,
  );
};

// NOVOS END POINTS
const atualizarProduto = (params) => {
  return Vue.prototype.$http.put(`${ip}/icms/produto/isento`, params);
};

const cadastrarIsentosEmpresa = (params) => {
  return Vue.prototype.$http.post(`${ip}/icms/produto/isento`, params);
};

const deleteProdutoEmpresa = ({ idEmpresa, ...rest }) => {
  /* codItem=&itemIsencao= */
  return Vue.prototype.$http.delete(
    `${ip}/icms/produto/isento/empresa/${idEmpresa}?${queryString.stringify(rest)}`,
  );
};

const retrieveIsentosEmpresa = (params) => {
  /* dtInicial=&dtFinal=limit=&offset= */
  return Vue.prototype.$http.get(
    `${ip}/icms/produtos/isentos/empresa/${params.idEmpresa}?${queryString.stringify(params)}`,
  );
};

const referenciarEmpresa = ({ idEmpresa, ...rest }) => {
  return Vue.prototype.$http.post(
    `${ip}/icms/produto/isento/empresa/${idEmpresa}`,
    rest,
  );
};

const retrieveIsentosFornecedor = (params) => {
  // idEmpresa=dtInicial=&dtFinal=limit=&offset=
  return Vue.prototype.$http.get(
    `${ip}/icms/produtos/isentos/fornecedor?${queryString.stringify(params)}`,
  );
};

const deletarOcultosEmpresa = ({ idEmpresa, ...query }) => {
  // codItem=&descrItem=
  return Vue.prototype.$http.delete(
    `${ip}/icms/produto/isento/empresa/${idEmpresa}/oculto?${queryString.stringify(query)}`,
  );
};

const ocultarIsentosEmpresa = ({ idEmpresa, ...rest }) => {
  // [ { codItem, descrItem } ]
  return Vue.prototype.$http.post(
    `${ip}/icms/produto/isento/empresa/${idEmpresa}/oculto`,
    rest,
  );
};

const ocultarIsentosFornecedor = ({ hashKey, ...data }) => {
  // { cpfCnpj, cProd, xProd, hashKey, _idx }
  return Vue.prototype.$http.post(
    `${ip}/icms/produto/isento/fornecedor/oculto?${queryString.stringify({ hashKey })}`,
    data.data,
  );
};

const deletarOcultosFornecedor = (query) => {
  // hashKey=&_idx=&cpfCnpj=&cProd=&xProd=
  return Vue.prototype.$http.delete(
    `${ip}/icms/produto/isento/fornecedor/oculto?${queryString.stringify(query)}`,
  );
};

const deleteIsentos = (item) => {
  return Vue.prototype.$http.delete(
    `${ip}/icms/produto/isento?${queryString.stringify(item)}`,
  );
};

const deleteProdutoFornecedor = (params) => {
  /* item=&cpfCnpj=&cProd=&operacao= */
  return Vue.prototype.$http.delete(
    `${ip}/icms/produto/isento/fornecedor?${queryString.stringify(params)}`,
  );
};

const referenciarFornecedor = (params) => {
  // [{ "item": 0, "cpfCnpj": "", "cProd": "", "operacao": "" }]
  return Vue.prototype.$http.post(
    `${ip}/icms/produto/isento/fornecedor`,
    params,
  );
};

const retrieveIsentos = ({ dtFinal }) => {
  return Vue.prototype.$http.get(
    `${ip}/icms/produtos/isentos/vigencia/${dtFinal}`,
  );
};

const getProductsRIcms = (params) => {
  // ?idEmpresa=69&dtInicial=2020-01-01&dtFinal=2020-01-03&fts=&limit=&offset=
  return Vue.prototype.$http.get(
    `${ip}/icms/ricms/produtos/empresa/${params.idEmpresa}?${queryString.stringify(params.query)}`,
  );
};

const getProductsRIcmsByCod = (params) => {
  // ?periodo=2020-01-03&fts=
  return Vue.prototype.$http.get(
    `${ip}/icms/ricms/produtos/empresa/${params.idEmpresa}/codigo?${queryString.stringify(
      params.query,
    )}&fts[]=${params.fts}`,
  );
};

const updateProductsRIcms = ({ idEmpresa, ...rest }) => {
  // icms/consumo/produtos/empresa/12
  return Vue.prototype.$http.put(
    `${ip}/icms/ricms/produtos/empresa/${idEmpresa}`,
    rest.payload,
  );
};

// Consumo

const getProductsConsumption = (params) => {
  // ?periodo=2020-01-03
  return Vue.prototype.$http.get(
    `${ip}/icms/consumo/produtos/empresa/${params.idEmpresa}?${queryString.stringify(params.query)}`,
  );
};
const updateProductsConsumption = ({ idEmpresa, ...rest }) => {
  // icms/consumo/produtos/empresa/12
  return Vue.prototype.$http.patch(
    `${ip}/icms/consumo/produtos/empresa/${idEmpresa}`,
    rest.payload,
  );
};
const insertProductsConsumption = ({ idEmpresa, ...rest }) => {
  // icms/consumo/produtos/empresa/12
  return Vue.prototype.$http.post(
    `${ip}/icms/consumo/produtos/empresa/${idEmpresa}`,
    rest.payload,
  );
};
const deleteProductsConsumption = ({ idEmpresa, ...rest }) => {
  // icms/consumo/produtos/empresa/12
  return Vue.prototype.$http.put(
    `${ip}/icms/consumo/produtos/empresa/${idEmpresa}`,
    rest.payload,
  );
};

// Relatório comparação
const getProdutosComDivergencia = (query) => {
  // icms/ricms/produtos/empresa/12/divergencia?periodo=2020-03-20&fts=preserva
  return Vue.prototype.$http.get(
    `${ip}/icms/ricms/produtos/empresa/${query.idEmpresa}/divergencia?${queryString.stringify(
      query,
    )}`,
  );
};

const getDiferenciadaByNcm = (query) => {
  // produtos/aliquota/diferenciada?fts=33043000|33043021
  return Vue.prototype.$http.get(
    `${ip}/icms/produtos/aliquota/diferenciada?fts=${query}`,
  );
};

const getPobrezaByNcm = (query) => {
  // icms/produtos/fundo/pobreza?fts=33043000|33043021
  return Vue.prototype.$http.get(
    `${ip}/icms/produtos/fundo/pobreza?fts=${query}`,
  );
};

const getIsentosByNcm = (query) => {
  // icms/produtos/isentos?fts=33043000|33043021
  return Vue.prototype.$http.get(`${ip}/icms/produtos/isentos?fts=${query}`);
};

const getReducaoByNcm = (query) => {
  // icms/produtos/reducao?fts=33043000|33043021
  return Vue.prototype.$http.get(`${ip}/icms/produtos/reducao?fts=${query}`);
};

const getSubstituicaoByNcm = (query) => {
  // icms/produtos/substituicao?fts=33043000|33043021
  return Vue.prototype.$http.get(
    `${ip}/icms/produtos/substituicao?fts=${query}`,
  );
};

const getSubstituicao = (fts, limit) => {
  // icms/produtos/substituicao?fts=33043000|33043021
  return Vue.prototype.$http.get(
    `${ip}/icms/produtos/substituicao?fts=${fts}&limit=${limit}`,
  );
};

const getProductPautaByNcmOrDescription = (query) => {
  // icms/produtos/substituicao?fts=33043000|33043021
  return Vue.prototype.$http.get(`${ip}/icms/produtos/pauta?fts=${query}`);
};

const getAliqDiffEntry = (query) => {
  // icms/efd/entrada/difal?idReg0000=81759
  return Vue.prototype.$http.get(
    `${ip}/icms/efd/entrada/difal?${queryString.stringify(query)}`,
  );
};

const fixEfdIcmsDifalThird = (query) => {
  // icms/efd/entrada/difal?idEmpresa=2370&date=2024-03-01
  return Vue.prototype.$http.get(
    `${ip}/icms/fix/efd/icms/difal/third?${queryString.stringify(query)}`,
  );
};

const deleteAliqDiffEntry = (query) => {
  // icms/efd/entrada/difal?idReg0000=81759idRegC100=012121
  return Vue.prototype.$http.delete(
    `${ip}/icms/efd/entrada/difal?${queryString.stringify(query)}`,
  );
};

const genaratePdfGuia = (query) => {
  // /guias?ie=131969617&referenceDate=08/2023&keyNote=35230600327385000287550030001375091001193525&expiringDate=23/09/2023&tributeValue=268.21
  return Vue.prototype.$http.get(
    `${ip}/icms/guias?${queryString.stringify(query)}`,
    {
      responseType: "blob",
    },
  );
};

const exportAliqNfeKeys = (data) =>
  Vue.prototype.$http.post(`${ip}/doc-miner/v2/diferencial/aliquota`, data, {
    headers: {
      "Content-Type": "application/json",
    },
  });

const downloadFile = (url) =>
  Vue.prototype.$http.get(url, {
    responseType: "blob",
  });

export default {
  getSubstituicao,
  getDiferenciadaByNcm,
  insertProductsConsumption,
  getPobrezaByNcm,
  getIsentosByNcm,
  getReducaoByNcm,
  getSubstituicaoByNcm,
  updateProductsRIcms,
  updateProductsConsumption,
  deleteProductsConsumption,
  referenciarCadastradosFornecedor,
  referenciarCadastradosEmpresa,
  retrieveIsentosFornecedor,
  ocultarIsentosFornecedor,
  deletarOcultosFornecedor,
  cadastrarIsentosEmpresa,
  deleteProdutoFornecedor,
  retrieveIsentosEmpresa,
  deletarOcultosEmpresa,
  ocultarIsentosEmpresa,
  referenciarFornecedor,
  deleteProdutoEmpresa,
  getProdutosComDivergencia,
  referenciarEmpresa,
  atualizarProduto,
  retrieveIsentos,
  deleteIsentos,
  getProductsRIcms,
  getProductsRIcmsByCod,
  getProductsConsumption,
  getAliqDiffEntry,
  exportAliqNfeKeys,
  downloadFile,
  deleteAliqDiffEntry,
  getProductPautaByNcmOrDescription,
  genaratePdfGuia,
  fixEfdIcmsDifalThird,
};
